import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const addGenericFloatingError = () => FloatingAlertStore.addAlert({
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "payments.errorAlert.payment.title"
  }),
  message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "payments.errorAlert.payment.text_jsx",
    options: {
      href: window.location.href
    },
    elements: {
      Link
    }
  }),
  type: 'danger'
});
export default addGenericFloatingError;